import { AutogenModelEdiShipmatchRule, AutogenRowEdiShipmatchRule } from "./autogen/AutogenModelEdiShipmatchRule";

export class ModelEdiShipmatchRule extends AutogenModelEdiShipmatchRule<RowEdiShipmatchRule> {
	constructor() {
		super(RowEdiShipmatchRule);
	}
}

export class RowEdiShipmatchRule extends AutogenRowEdiShipmatchRule {
}